import React from 'react';
import blankFile from "../../assets/svg/blankFile.svg"
import video from "../../assets/svg/FileIcons/video.svg"
import music from "../../assets/svg/FileIcons/music.svg"
import docx from "../../assets/svg/FileIcons/docx.svg"
import ppt from "../../assets/svg/FileIcons/ppt.svg"
import url from "../../assets/svg/FileIcons/url.svg"
import zip from "../../assets/svg/FileIcons/zip.svg"
import pdf from "../../assets/svg/FileIcons/pdf.svg"
import xlsx from "../../assets/svg/FileIcons/ExcelIcon.svg";
import image from "../../assets/svg/FileIcons/imageicon.svg";
import formats from '../helpers/MediaFormats';

const FileIcon = ({ fileName }) => {

  if (fileName) {
    const fileType = fileName?.split(".").pop();
    const supportedFormats = Object.values(formats).flat();

    if (supportedFormats.includes(fileType)) {
      const findKeyByValue = (value, obj) => {
        for (let key in obj) {
          if (obj[key].includes(value)) {
            return key;
          }
        }
        return null;
      };

      const fileTypeKey = findKeyByValue(fileType, formats);

      if (fileTypeKey) {
        switch (fileTypeKey) {
          case "video":
            return <img src={video} alt="" className='mt-top'/>;

          case "audio":
            return <img src={music} alt="" className='mt-top'/>;

          case "word":
            return <img src={docx} alt="" className='mt-top'/>;

          case "pdf":
            return <img src={pdf} alt="" width={16} height={16} className='mt-top' />;

          case "ppt":
            return <img src={ppt} alt="" className='mt-top'/>;

          case "zip":
            return <img src={zip} alt="" className='mt-top'/>;

          case "image":
            return <img src={image} alt="" className='mt-top'/>;

          case "url":
            return <img src={url} alt="" className='mt-top'/>;

          case "xlsx":
            return <img src={xlsx} alt="" className='mt-top'/>;

          default:
            return <img src={blankFile} alt="" className='mt-top'/>;
        }
      } else {
        return <img src={blankFile} alt="" className='mt-top'/>;
      }
    } else {
      return <img src={blankFile} alt="" className='mt-top'/>;
    }
  }
};

export default FileIcon;
